import { Row, RowProps } from 'react-aria-components'

type TableRowProperties<T extends object> = RowProps<T> & {
    className?: string
}

export const TableRow = <T extends object>({
    ...properties
}: Readonly<TableRowProperties<T>>) => {
    return <Row {...properties} />
}
